import {BaseApi} from './base-api';
import Vue from 'vue';

export class ObjectGroupApi extends BaseApi {
  static apiUri = 'object-groups';

  /** @return {Promise<PagedHttpResponse<ObjectGroupDto>>} */
  static getAll () {
    return super.getAll();
  }

  /** @return {Promise<EntityHttpResponse<ObjectGroupDto>>} */
  static getById (id) {
    return super.getById(id);
  }

  /**
   * @param {ObjectGroupSaveRequest} objectGroupSaveRequest
   * @return {Promise<EntityHttpResponse<ObjectGroupDto>>}
   **/
  static create (objectGroupSaveRequest) {
    return Vue.http.post(this.apiUri, objectGroupSaveRequest);
  }

  /**
   * @param {number} objectGroupId
   * @param {ObjectGroupSaveRequest} objectGroupSaveRequest
   * @return {Promise<EntityHttpResponse<ObjectGroupDto>>}
   **/
  static update (objectGroupId, objectGroupSaveRequest) {
    return Vue.http.post(this.apiUri + '/' + objectGroupId, objectGroupSaveRequest);
  }

  /**
   * @param {number} objectGroupId
   * @return {Promise<HttpResponse>}
   **/
  static delete (objectGroupId) {
    return Vue.http.delete(this.apiUri + '/' + objectGroupId);
  }
}
